/* ============================================================================
   LONDON DELIVERED — live Shopify AJAX cart + drawer
   Talks to the real Shopify Cart API (/cart/add.js, /cart/change.js, /cart.js).
   Checkout is the real Shopify checkout. The £15.99 service fee is applied as a
   flat shipping rate at checkout (see INSTALL-GUIDE); shown here as a note + a
   progress bar toward the discount tiers.
   ============================================================================ */
(function () {
  'use strict';

  // ---- service-fee tiers (mirror these in Settings > Shipping price-based rates)
  var FEE = 15.99, DISC_THRESHOLD = 150, FREE_THRESHOLD = 500, DISC_RATE = 0.20;

  var $ = function (id) { return document.getElementById(id); };
  function money(cents) { return '£' + ((cents || 0) / 100).toFixed(2); }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  var overlay, drawer, toastTimer;

  function feeFor(subPounds, count) {
    if (count === 0) return { fee: FEE, state: 'none' };
    if (subPounds >= FREE_THRESHOLD) return { fee: 0, state: 'free' };
    if (subPounds >= DISC_THRESHOLD) return { fee: +(FEE * (1 - DISC_RATE)).toFixed(2), state: 'disc' };
    return { fee: FEE, state: 'full' };
  }

  function toast(msg) {
    var t = $('ld-toast'); if (!t) return;
    $('ld-toastmsg').textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 1800);
  }

  function openDrawer() { if (overlay) overlay.classList.add('open'); if (drawer) drawer.classList.add('open'); var c = $('ld-dclose'); if (c) c.focus(); }
  function closeDrawer() { if (overlay) overlay.classList.remove('open'); if (drawer) drawer.classList.remove('open'); }

  // ---- Cart API ----
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  // ---- Render ----
  function render(cart) {
    var count = cart.item_count;
    var subPounds = cart.items_subtotal_price / 100;

    var cc = $('cartcount'); if (cc) cc.textContent = count;

    var mbar = $('ld-mbar');
    if (mbar) {
      $('ld-mc').textContent = count + (count === 1 ? ' item' : ' items');
      $('ld-ms').textContent = money(cart.items_subtotal_price);
      mbar.classList.toggle('show', count > 0);
    }

    // progress toward fee tiers
    var bar = $('ld-progbar');
    if (bar) bar.style.width = Math.min(100, FREE_THRESHOLD > 0 ? (subPounds / FREE_THRESHOLD * 100) : 0) + '%';
    var lbl = $('ld-proglbl');
    if (lbl) {
      var toDisc = DISC_THRESHOLD - subPounds, toFree = FREE_THRESHOLD - subPounds;
      if (count === 0) lbl.innerHTML = 'Spend <b>£' + DISC_THRESHOLD.toFixed(2) + '</b> for 20% off the service fee — or <b>£' + FREE_THRESHOLD.toFixed(2) + '</b> to make it free.';
      else if (toDisc > 0) lbl.innerHTML = 'Add <b>£' + toDisc.toFixed(2) + '</b> more for <b>20% off</b> the £15.99 service fee.';
      else if (toFree > 0) lbl.innerHTML = '<b>20% off unlocked.</b> Add <b>£' + toFree.toFixed(2) + '</b> more to make your service fee free.';
      else lbl.innerHTML = '<b>Service fee waived</b> — delivery included, free.';
    }

    // line items
    var body = $('ld-dbody');
    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<div class="dempty">Your basket is empty.<br>Add the cases London reorders most.</div>';
      } else {
        body.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1$2') : '';
          var vt = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="vd">' + esc(it.variant_title) + '</div>' : '';
          return '<div class="ditem">' +
            '<span class="pic">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</span>' +
            '<div class="meta"><div class="nm">' + esc(it.product_title) + '</div>' + vt +
            '<div class="pr">' + money(it.final_line_price) + '</div>' +
            '<span class="dq"><button type="button" aria-label="Decrease" data-step="-1" data-key="' + it.key + '">−</button><span>' + it.quantity + '</span><button type="button" aria-label="Increase" data-step="1" data-key="' + it.key + '">+</button></span>' +
            '<button class="rm" type="button" data-remove="' + it.key + '">Remove</button>' +
            '</div></div>';
        }).join('');
      }
    }

    // totals
    var f = feeFor(subPounds, count);
    var dsub = $('ld-dsub'); if (dsub) dsub.textContent = money(cart.items_subtotal_price);
    var dfee = $('ld-dfee');
    if (dfee) {
      if (f.state === 'free') dfee.innerHTML = '<span class="free">FREE</span>';
      else if (f.state === 'disc') dfee.innerHTML = '<s style="opacity:.55;margin-right:4px">£' + FEE.toFixed(2) + '</s> <span class="free">£' + f.fee.toFixed(2) + '</span>';
      else dfee.textContent = '£' + f.fee.toFixed(2);
    }
    var dtot = $('ld-dtot'); if (dtot) dtot.textContent = money(cart.items_subtotal_price + Math.round(f.fee * 100));
  }

  function refresh(open) {
    return getCart().then(function (cart) { render(cart); if (open) openDrawer(); return cart; });
  }

  // ---- Wire up ----
  document.addEventListener('DOMContentLoaded', function () {
    overlay = $('ld-overlay'); drawer = $('ld-drawer');

    var cartlink = $('cartlink'); if (cartlink) cartlink.addEventListener('click', function () { refresh(true); });
    var mbarbtn = $('ld-mbarbtn'); if (mbarbtn) mbarbtn.addEventListener('click', function () { refresh(true); });
    var dclose = $('ld-dclose'); if (dclose) dclose.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    // intercept all card/product add forms
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ld-add], form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var id = form.querySelector('[name="id"]').value;
      var qtyEl = form.querySelector('[name="quantity"]');
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; }
      addToCart(id, qty)
        .then(function () { return refresh(true); })
        .then(function () { toast('Added to basket'); })
        .catch(function (err) { toast((err && err.description) || 'Could not add item'); })
        .then(function () { if (btn) btn.disabled = false; });
    });

    // drawer qty + remove (event delegation)
    var body = $('ld-dbody');
    if (body) {
      body.addEventListener('click', function (e) {
        var stepBtn = e.target.closest('[data-step]');
        var rmBtn = e.target.closest('[data-remove]');
        if (stepBtn) {
          var key = stepBtn.getAttribute('data-key');
          var dir = parseInt(stepBtn.getAttribute('data-step'), 10);
          var qtySpan = stepBtn.parentNode.querySelector('span');
          var newQty = (parseInt(qtySpan.textContent, 10) || 1) + dir;
          changeLine(key, Math.max(0, newQty)).then(render);
        } else if (rmBtn) {
          changeLine(rmBtn.getAttribute('data-remove'), 0).then(render);
        }
      });
    }

    // initial paint
    refresh(false);
  });
})();
